module.exports = __webpack_public_path__ + "static/media/googlePin14.804a7300.svg";